import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ArrowBack, Home, Lock, Person, QrCodeScanner, Settings, TrendingUp } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setToken } from '../../redux/actions/action';
import { useEffect } from 'react';
import { Backdrop, CircularProgress, Button } from '@mui/material';
import { useState } from 'react';
import { COLOR_BACKGROUND_WHITE_CLARO, CustomBackdrop } from '../../styles/Styles';
import { LogoSicoop } from '../logos/LogoImg';
import { VERSION_APP } from '../../api/Api';
import { handleDispositivo } from '../hooks/HooksGlobal';

const drawerWidth = 240;

const ConfigNameDrawer = [
    {
        title: 'Generar QR',
        icon: <QrCodeScanner />,
        path: '/home',
        visible: true,
    },
    {
        title: 'Historial',
        icon: <TrendingUp />,
        path: '/historial',
        visible: true,
    },
    {
        title: 'Mis Datos',
        icon: <Person />,
        path: '/perfil',
        visible: true,
    },
    {
        title: 'Seguridad',
        icon: <Lock />,
        path: '/seguridad',
        visible: true,
    },
    {
        title: 'Configuración',
        icon: <Settings />,
        path: '/settings',
        visible: false,
    },
];



const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        minWidth: 0,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        // marginLeft: `-${drawerWidth}px`,

        // backgroundColor: COLOR_BACKGROUND_WHITE_CLARO,
        // height: '100vh',
        // overflow: 'auto',
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        // width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    // justifyContent: 'flex-end',
    flexDirection: 'column',
    justifyContent: 'center',
}));

export default function HeaderCustom({ children, title }) {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [cargando, setCargando] = useState(false);

    // console.log('title===', title);

    //agregar el title a la pagina
    document.title = title;

    let history = useNavigate();
    let navActual = useLocation().pathname;

    //si navActual es igual al path de ConfigNameDrawer, muestra el icono de menu, si no muestra el icono de regresar
    let navIcons = ConfigNameDrawer.some((item) => item.path === navActual);

    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log('satate', stateToken);

    const dispatch = useDispatch();

    const dataLocalStorage = () => {
        let nameLocal = localStorage.getItem('dataUser');
        if (nameLocal === null) {
            history('/');
        }
    }

    useEffect(() => {
        dataLocalStorage();
    }, [])

    const handleRutes = (path) => {
        history(path);
    };

    const handleGoBack = () => {
        history(-1);
    };

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    //--------------------------------cerrar sesion de login
    const closeLogin = () => {
        setCargando(true);
        setTimeout(() => {
            localStorage.removeItem('dataUser');
            dispatch(setToken(null));
            setCargando(false);
            history('/');
        }, 2000);
    }

    //cierra la app
    const handleCloseApp = async () => {

        //enviar el mensaje a la webView de react native, para que se pueda cerrar la app
        if (window.ReactNativeWebView) {//se valida si es una app de react native
            handleDrawerClose();
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'closeApp' }));
        }

    }


    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar position="fixed" open={open} color='primary'>
                <Toolbar>
                    {/* si las rutas son diferentes a home, se muestra el icono de regresar */}
                    {navIcons ?
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            sx={{ mr: 2, ...(open && { display: 'none' }) }}
                        >
                            <MenuIcon />
                        </IconButton>
                        :
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => handleGoBack()}
                            edge="start"
                            sx={{ mr: 2, ...(open && { display: 'none' }) }}
                        >
                            <ArrowBack />
                        </IconButton>
                    }
                    {/* <Typography variant="h6" noWrap component="div">
                        Sicoop
                    </Typography> */}
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: '#f0f8ff',
                    },
                }}
                // variant="persistent"
                anchor="left"
                onClose={handleDrawerClose}
                open={open}
            >
                <DrawerHeader>
                    <LogoSicoop tamano={150} />

                    <div style={{
                        padding: '10px',
                    }}>
                        <Typography variant="subtitle1" component="div" align='center'>
                            {stateToken?.usuarioNombre.toUpperCase()}
                        </Typography>
                    </div>

                    {/* <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton> */}
                </DrawerHeader>
                <Divider />
                <List>
                    {ConfigNameDrawer.map((item, index) => (
                        //visualizar solo los que estan en visible=true 
                        item.visible &&
                        (
                            <>
                                {handleDispositivo() === 'Android' ?
                                    <ListItem key={index} disablePadding>
                                        <ListItemButton onClick={() => item.path ? handleRutes(item.path) : closeLogin()}>
                                            <ListItemIcon>
                                                {item.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={item.title} />
                                        </ListItemButton>
                                    </ListItem>
                                    :
                                    (
                                        <>
                                            {
                                                item.path !== '/seguridad' &&
                                                <>
                                                    {handleDispositivo() === 'iOS' ?
                                                        <ListItem key={index} disablePadding>
                                                            <ListItemButton onClick={() => item.path ? handleRutes(item.path) : closeLogin()}>
                                                                <ListItemIcon>
                                                                    {item.icon}
                                                                </ListItemIcon>
                                                                <ListItemText primary={item.title} />
                                                            </ListItemButton>
                                                        </ListItem>

                                                        :
                                                        item.path !== '/settings' &&
                                                        <ListItem key={index} disablePadding>
                                                            <ListItemButton onClick={() => item.path ? handleRutes(item.path) : closeLogin()}>
                                                                <ListItemIcon>
                                                                    {item.icon}
                                                                </ListItemIcon>
                                                                <ListItemText primary={item.title} />
                                                            </ListItemButton>
                                                        </ListItem>

                                                    }
                                                </>
                                            }
                                        </>
                                    )


                                }
                            </>
                        )
                    ))}
                </List>
                <Box
                    mb={2}
                    textAlign="center"
                    sx={{
                        position: 'absolute',
                        bottom: '0',
                        width: '100%',
                    }}
                >
                    {handleDispositivo() === 'Android' &&
                        <List>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => handleCloseApp()}>
                                    <ListItemText primary={"Salir"} />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    }

                    <Divider />
                    <Typography
                        variant="body2"
                        style={{
                            color: '#0000008a',
                            fontSize: '0.8rem',
                            marginTop: '10px',

                        }}
                    >
                        Versión {VERSION_APP}
                    </Typography>
                </Box>

            </Drawer>
            <Main open={open}>
                <DrawerHeader />
                {children}
            </Main>
            <CustomBackdrop open={cargando}>
                <CircularProgress color="inherit" />
            </CustomBackdrop>
        </Box >
    );
}
